import React from 'react';
import { ToastContainer } from 'react-toastify';
import { AuthContextProvider } from './context/AuthContext';
import Router from './components/routes';

function App() {

  return (
    <div className='App'>
      <AuthContextProvider>
        <Router />
      </AuthContextProvider>
      <ToastContainer
        hideProgressBar={true}
        theme="colored"
      />
    </div>
  );
}

export default App;
